export default __webpack_public_path__ + "ff456035683eaacba92b0e8ec2a032b3.svg";